import { playerInfo } from '../../utils';

export const NIELSEN_INSTANCE_NAME = `Magnetoscope_${playerInfo().version}`;
export const NIELSEN_LIB_NAME = 'NOLBUNDLE';
export const NIELSEN_DEBUG = 'debug';

export const NIELSEN_EVENT_LOADEDMETADATA = 'loadMetadata';
export const NIELSEN_EVENT_SET_PLAYHEAD_POSITION = 'setPlayheadPosition';
export const NIELSEN_EVENT_STOP = 'stop';
export const NIELSEN_EVENT_END = 'end';
